module.exports = __webpack_public_path__ + "static/ritorno-4ab8bc071f0fd2f4b126cff319f843ba.svg";